import { combineReducers } from 'redux';

import homepage from './homepageReducer';
import topRanked from './topRankedReducer';
import resources from './resourcesReducer';
import coreUI from './coreUIReducer';
import notifications from './notificationsReducer';
import coreApp from './coreAppReducer';
import events from './eventReducer';
import ptsRankings from './ptsRankingReducer';
import homepageV2 from './v2/homepageReducer';
import playersPageV2 from './v2/playersPageReducer';
import organizersPageV2 from './v2/organizersPageReducer';
import flexLeaguePageV2 from './v2/flexleagueReducer';
import howUtrWorksPageV2 from './v2/howUtrWorksPageReducer';
import matchPlayPageV2 from './v2/matchplayPageReducer';
import powerSubscriptionPageV2 from './v2/powerSubscriptionPageReducer';
import forCollegeCoachesPageV2 from './v2/forCollegeCoachesReducer';
import teamTennisPageV2 from './v2/teamTennisPageReducer';
import flexLeaguePageTemplate from './v2/flexLeagueTemplateReducer';
import itaTourPageV2 from './v2/itaTourPageReducer';
import forHighSchoolCoachesPageV2 from './v2/forHighschoolCoachesPageReducer';
import utSchoolPageV2 from './v2/utSchoolReducer';
import utrProTennisSeriesPageV2 from './v2/utrProTennisSeriesPageReducer';
import proTennisPageV2 from './v2/proTennisPageReducer';
import pressPageV2 from './v2/pressPageReducer';
import academiesPageV2 from './v2/academiesPageReducer';
import calendarPageV2 from './v2/calendarPageReducer';
import clubsPageV2 from './v2/clubsPageReducer';
import collegePathwaysPageV2 from './v2/collegePathwaysPageReducer';
import discoverPageV2 from './v2/discoverPageReducer';
import federationPageV2 from './v2/federationPageReducer';
import gettingStartedPageV2 from './v2/gettingStartedPageReducer';
import insightsPageV2 from './v2/insightsPageReducer';
import newsPageV2 from './v2/newsPageReducer';
import user from './userReducer';
import clubs from './clubReducer';
import flexLeagueAustinPageV2 from './v2/flexleagueAustinReducer';
import flexLeagueBostonPageV2 from './v2/flexleagueBostonReducer';
import flexLeagueDenverPageV2 from './v2/flexleagueDenverReducer';
import flexLeagueSacramentoPageV2 from './v2/flexleagueSacramentoReducer';
import rankingsPageV2 from './v2/rankingsPageReducer';
import aboutUsPageV2 from './v2/aboutUsReducer';
import flexLeaguePointsRacePageV2 from './v2/flexleaguePointsRaceReducer';
import flexLeagueWinnersPageV2 from './v2/flexleagueWinnersReducer';
import flexLeagueSocialPageV2 from './v2/flexleagueSocialReducer';
import northCalPageV2 from './v2/northCalReducer';
import paidHitsPageV2 from './v2/paidHitsReducer';
import pttRankingsPageV2 from './v2/pttRankingsReducer';
import testPageV2 from './v2/testPageReducer';
import adultLeaguesPageV2 from './v2/adultLeaguesReducer';
import nationalPathwayPageV2 from './v2/nationalPathwayPageReducer';
import paidHittersPageV2 from './v2/paidHittersPageReducer';
import iOSAppPageV2 from './v2/iosAppPageReducer';
import australiaPageV2 from './v2/australiaPageReducer';
import australiaNewUserPageV2 from './v2/australiaNewUserPageReducer';
import australiaTaUserPageV2 from './v2/australiaTaUserPageReducer';
import australiaUtUserPageV2 from './v2/australiaUtUserPageReducer';
import juniorCircuitsPageV2 from './v2/juniorCircuitsPageReducer';
import australiaRanked from './australiaRankedReducer';
import collegeCampsPageV2 from './v2/collegeCampsPageReducer';
import internationalCircuitsPageV2 from './v2/internationalCircuitsPageReducer';
import collegeCircuitsPageV2 from './v2/collegeCircuitsPageReducer';
import headerMenuTabs from './v2/headerMenuTabsReducer';
import footerHyperLinks from './v2/footerHyperLinksReducer';
import juniorTeamTennisV2 from './v2/juniorTeamTennisPageReducer';
import claimYourProfilePageV2 from './v2/claimYourProfilePageReducer';
import adultTeamTennisV2 from './v2/adultTeamTennisPageReducer';
import pickleball from './v2/pickleballReducer';
import contest from './v2/contestReducer';
import juniorCircuitsGritLeaderboard from './v2/juniorCircuitsGritLeaderboardPageReducer';
import dingles from './v2/dinglesPageReducer';
import foundation from './v2/foundationPageReducer';
import progressionball from './v2/progressionBallPageReducer';
import collegeCorner from './v2/collegeCornerReducer';
import collegeMatchday from './v2/collegeMatchdayReducer';
import collegeShowcase from './v2/collegeShowcaseReducer';
import collegiateAlliance from './v2/collegiateAllianceReducer';

export default combineReducers({
    homepage,
    topRanked,
    resources,
    coreUI,
    notifications,
    coreApp,
    events,
    ptsRankings,
    homepageV2,
    playersPageV2,
    organizersPageV2,
    flexLeaguePageV2,
    howUtrWorksPageV2,
    matchPlayPageV2,
    powerSubscriptionPageV2,
    forCollegeCoachesPageV2,
    teamTennisPageV2,
    flexLeaguePageTemplate,
    itaTourPageV2,
    forHighSchoolCoachesPageV2,
    utSchoolPageV2,
    utrProTennisSeriesPageV2,
    proTennisPageV2,
    pressPageV2,
    academiesPageV2,
    calendarPageV2,
    clubsPageV2,
    collegePathwaysPageV2,
    discoverPageV2,
    federationPageV2,
    gettingStartedPageV2,
    insightsPageV2,
    newsPageV2,
    user,
    clubs,
    flexLeagueAustinPageV2,
    flexLeagueBostonPageV2,
    flexLeagueDenverPageV2,
    flexLeagueSacramentoPageV2,
    rankingsPageV2,
    aboutUsPageV2,
    flexLeaguePointsRacePageV2,
    flexLeagueWinnersPageV2,
    flexLeagueSocialPageV2,
    northCalPageV2,
    paidHitsPageV2,
    pttRankingsPageV2,
    testPageV2,
    adultLeaguesPageV2,
    nationalPathwayPageV2,
    paidHittersPageV2,
    iOSAppPageV2,
    australiaPageV2,
    australiaNewUserPageV2,
    australiaTaUserPageV2,
    australiaUtUserPageV2,
    juniorCircuitsPageV2,
    australiaRanked,
    collegeCampsPageV2,
    internationalCircuitsPageV2,
    collegeCircuitsPageV2,
    headerMenuTabs,
    footerHyperLinks,
    juniorTeamTennisV2,
    claimYourProfilePageV2,
    adultTeamTennisV2,
    pickleball,
    contest,
    juniorCircuitsGritLeaderboard,
    dingles,
    foundation,
    progressionball,
    collegeCorner,
    collegeMatchday,
    collegeShowcase,
    collegiateAlliance,
});
